













































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { GrabPostProperties } from "@/services/posts/postTypes/grab";
import GrabItemPreviewModal from "@/components/posts/grab/modals/GrabItemPreviewModal.vue";
import { RenderPostModel } from "@/services/render/types";
import validate from "@/directives/validate";
import { propertiesValidators } from "@/components/posts/grab/validators";
import { validateForm } from "@/services/validation/validationService";

@Component({
    components: {
        GrabItemPreviewModal
    },
    directives: {
        validate
    }
})
export default class GrabForm extends Vue {
    @Prop() private properties!: GrabPostProperties;
    @Prop() private channelHeight!: number;
    @Prop() private channelWidth!: number;
    @Prop() defaultShowTime!: number;

    localProperties = {} as GrabPostProperties;
    validators = propertiesValidators;

    // lifecycle hooks
    created() {
        if (this.properties) {
            this.localProperties = this.properties;
        }
        this.setDefaultValues();
    }

    // watchers
    @Watch("defaultShowTime")
    onDefaultShowTimeChanged() {
        if (this.localProperties.showTime) return;
        this.$set(this.localProperties, "showTime", this.defaultShowTime);
    }

    @Watch("properties")
    onContentChanged() {
        this.localProperties = this.properties;
        this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
    }

    get defaultSize() : any {
        const size = {
            width: (this.localProperties.width || this.channelWidth) || 0,
            height: (this.localProperties.height || this.channelHeight) || 0
        };
        this.localProperties.width = size.width;
        this.localProperties.height = size.height;
        this.localProperties.grabWidth = this.localProperties.grabWidth || 1920;
        this.localProperties.grabHeight = this.localProperties.grabHeight || 1080;
        this.$nextTick(() => {
            this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
        });
        return size;
    }

    // methods
    previewItem() {
        var grabItem = {} as RenderPostModel;
        this.localProperties.width = this.defaultSize.width;
        this.localProperties.height = this.defaultSize.height;
        grabItem.properties = this.localProperties;
        (this.$refs.itemPreviewModal as any).open(grabItem);
    }

    setDefaultValues() {
        this.localProperties.reloadTime = this.localProperties.reloadTime || 0;
        this.localProperties.zoom = this.localProperties.zoom || 100;
        this.localProperties.x = this.localProperties.x || 0;
        this.localProperties.y = this.localProperties.y || 0;
        this.localProperties.url = this.localProperties.url || "";
        this.localProperties.width = this.defaultSize.width;
        this.localProperties.height = this.defaultSize.height;
        this.$nextTick(() => {
            this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
        });
    }

    async validateData() {
        return await validateForm([this.validators]);
    }

    emitData() {
        this.localProperties.width = this.defaultSize.width;
        this.localProperties.height = this.defaultSize.height;
        this.$emit("propertiesUpdated", this.localProperties);
    }

    setItemName() {
        var name = this.localProperties.url;
        this.$emit("itemNameUpdated", name);
    }
}
